"use client"

import { LoadingSpinner } from "@/components/ui/spinner"
import type { Plan } from "./types"

interface PriceDisplayProps {
    price: number;
    interval: string;
    plan: Plan;
    discountApplied?: boolean;
    originalPrice?: number;
}

export function PriceDisplay({ price, interval, plan, discountApplied, originalPrice }: PriceDisplayProps) {
    if (plan.type === "custom") {
        return (
            <div className="flex flex-row gap-2 justify-between">
                <div className="flex gap-0.5">
                    <div className="text-3xl font-bold">Custom</div>
                </div>
            </div>
        );
    }

    const monthlyPrice = interval === "year" ? Math.ceil(price / 12) : Math.ceil(price);
    const monthlyOriginalPrice = interval === "year" && originalPrice ? Math.ceil(originalPrice / 12) : originalPrice;

    let displayPrice: string;
    let displayOriginalPrice: string | undefined;

    if (discountApplied && (!price || !originalPrice)) {
        displayPrice = "";
        displayOriginalPrice = undefined;
    } else {
        displayPrice = "$" + monthlyPrice.toLocaleString();
        displayOriginalPrice = discountApplied ? "$" + (monthlyOriginalPrice?.toLocaleString() ?? "") : undefined;
    }

    if (!displayPrice) {
        return <LoadingSpinner />;
    }

    return (
        <div className="flex flex-row gap-2 justify-between">
            <div className="flex gap-0.5">
                <div className="text-3xl font-bold">{displayPrice}</div>
                <div className="flex flex-col py-3 text-sm">/month</div>
            </div>
            {discountApplied && displayOriginalPrice && (
                <div className="flex flex-row line-through">
                    <span className="text-black text-2xl font-bold">{displayOriginalPrice}</span>
                    <div className="flex flex-col py-3 text-sm">/month</div>
                </div>
            )}
        </div>
    );
}